// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16zqS","signatureBlock":"Footer_signatureBlock__KhVp1","signature":"Footer_signature__gF0c2"};